// NOTE: we are explicitly using an antd checkbox here because removing this breaks the import order
//  removing this will require a larger refactor effort - so beware
import { WebViewerInstance } from '@pdftron/webviewer';
import { Checkbox } from 'antd';

import { pdfStore } from 'modules/common/viewer/pdfViewer/WebViewerContext';

type SnappingCheckboxProps = {
  instance: WebViewerInstance;
  pdfStore: typeof pdfStore;
};

export const setMeasurementToolSnapMode = (
  instance: WebViewerInstance,
  nextIsSnappingEnabled: boolean,
) => {
  const toolModeMap = instance.Core.documentViewer.getToolModeMap();
  Object.values(toolModeMap).forEach((tool) => {
    // Check if tool exists, has measurement capabilities, and supports snap mode
    if (tool?.Measure && typeof tool.setSnapMode === 'function') {
      const snapMode = nextIsSnappingEnabled
        ? instance.Core.Tools.SnapModes.POINT_ON_LINE // Enable snapping to point on line
        : null; // Disable snapping

      tool.setSnapMode(snapMode);
    }
  });
};

export const SnappingCheckbox = ({
  instance,
  pdfStore,
}: SnappingCheckboxProps) => {
  const onToggle = () => {
    const nextIsSnappingEnabled = !pdfStore.isSnappingEnabled;

    setMeasurementToolSnapMode(instance, nextIsSnappingEnabled);

    // Update store after side effect handled
    pdfStore.isSnappingEnabled = nextIsSnappingEnabled;

    // Update the checkbox to reflect the change
    const checkboxElement = document.getElementById(
      'snapping-checkbox',
    ) as HTMLInputElement;
    if (checkboxElement) {
      checkboxElement.checked = nextIsSnappingEnabled;
    }
  };

  return (
    <>
      <Checkbox
        type="checkbox"
        id="snapping-checkbox"
        defaultChecked={pdfStore.isSnappingEnabled}
        onChange={onToggle}
        style={{ display: 'flex', alignItems: 'center', height: '100%' }}
      >
        Snap
      </Checkbox>
    </>
  );
};
